import React, { useState } from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText, FDBox, FDHeadlineText, FDPaper, FDStack,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { GuidedHouseholdReviewZoneDescriptions } from 'Components/UI/guidedHouseholdReview/zoneDescriptions';
import {
  GoalIconWithThresholdIcon,
} from 'Views/Page/Content/Templates/guidedHouseholdReviewLeversTransitionPageTemplate/GoalIconWithThresholdIcon';

const useStyles = buildUseStyles('GuidedHouseholdReviewLeversTransitionLayout', (theme) => ({
  root: {
    position: 'relative',
    width: '80%',
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    '& img': {
      display: 'block',
      minWidth: 0,
    },
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // Vertically center the content
    display: 'flex',
    alignItems: 'center',
    // For this image, this allows the content to avoid colliding with the image
    paddingLeft: '20%',
    paddingRight: '20%',
  },
  whiteText: {
    // Because this image is blue and FD doesn't know about it, we need to make the text white.
    // It might seem like a better solution would be to have an emphasis background behind this, but this image comes with translucent padding that would actually fuck up the emphasized background!
    '& .FD-MuiTypography-root': {
      color: theme.palette.common.white,
    },
  },
}));
export const GuidedHouseholdReviewLeversTransitionLayout = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();
  const [imgLoaded, setImgLoaded] = useState(!resource.relationship(fr.relationships.image.name));
  return (
    <div className={classes.root} style={{ aspectRatio: resource.relationship(fr.relationships.image.name).meta('aspectRatio') }}>
      <img
        src={resource.relationship(fr.relationships.image.name).link('related').url()}
        alt=""
        onLoad={() => setImgLoaded(true)}
      />
      {imgLoaded ? (
        <div className={classes.content}>
          <FDBox padding={8}>
            <FDStack direction={'column'} spacing={3} justifyContent={'center'} alignItems={'center'}>
              <div className={classes.whiteText}>
                <FDHeadlineText
                  color="textPrimary"
                  value={resource.attr('title')}
                />
              </div>
              <FDPaper appearance="flat" padding={6}>
                <FDStack direction={'column'} spacing={2} justifyContent={'center'} alignItems={'center'}>
                  <FDStack direction="row" spacing={4} justifyContent="center">
                    {resource.attr('goals').resources().list().map((goal) => (
                      <GoalIconWithThresholdIcon key={goal.id()} resource={goal} />
                    ))}
                  </FDStack>
                  <GuidedHouseholdReviewZoneDescriptions resource={resource} />
                </FDStack>
              </FDPaper>
              <div className={classes.whiteText}>
                <FDBodyText value={resource.attr('description')} align={'center'} />
              </div>
            </FDStack>
          </FDBox>
        </div>
      ) : null}
    </div>
  );
};
